export default {
    product: {
        onStock: {
            label: "Na sklade"
        },
        outOfStock: {
            label: "Zvyčajne do 5 týždňov",
            tooltip: "Tento výrobok objednávame zo skladu nášho dodávateľa, kde by mal byť k dispozícii. Dodanie očakávajte predbežne do 5 týždňov od potvrdenia objednávky. Tento termín môže byť v závislosti na aktuálnej dostupnosti u dodávateľa prodložený bez kompenzačného nároku."
        },
        priceIsNotFinal: {
            label: "Cena môže byť upresnená",
            tooltip: "Táto cena môže byť upresnená v potvrdení objednávky, ktoré vám zašleme. Ak sa cena bude líšiť máte právo tovar z objednávky kedykoľvek bezplatne odobrať."
        },
        priceOnRequest: {
            label: "Cena na vyžiadanie",
            tooltip: "Nejedná sa o štandardný výrobok a preto vám cenu overíme u výrobcu po zaslaní objednávky. Pokiaľ s cenou nebudete súhlasiť máte právo objednávku zrušiť."
        },
        catalogNumber: "Kód tovaru:",
        cntVariants: "Pocet variant",
        displayVariants: "Zobraziť varianty",
        addToBasket: "Do košíka"
    },
    basket: {
        content: "Obsah košíku",
        goToBasket: "Prejsť do košíka",
        wizard: {
            overview: {
                headline: "Košík",
                totalPrice: "Celková cena:",
                shipping: "Poštovné a balné",
                empty:{
                    message: "Momentálne nemáte v košíku vložený žiadny tovar.",
                    addByCatalogNumber: "Pridať tovar podľa katalógového čísla"
                },
                continueWithShopping: "Pokračovať v nákupe",
                continueWithOrder: "Pokračovať v objednávce",
                requestPriceOffer: "Chcem nezáväznú cenovú ponuku"
            },
            contact: {
                orderHeadline: "Košík / Dokončenie objednávky",
                priceOfferHeadline: "Košík / žiadosť o cenovú ponuku",
                contactInfo: "Kontaktné údaje",
                email: "E-mail",
                phone: "Telefón",
                firstname: "Meno",
                lastname: "Priezvisko",
                street: "Ulica a č.d.",
                city: "Mesto",
                zipCode: "PSČ",
                country: "Krajina",
                billingInfo: "Fakturačné údaje",
                withWatOnly: "(*Dodávame iba zákazníkom s IČO)",
                company: "Názov firmy",
                regId: "IČO",
                flagVatId: "Som platca DPH",
                vatId: "DIČ",
                flagDeliveryInfo: "Chcem doručiť na inú adresu",
                shippingInfo: "Dodacia adresa",
                completeOnlyInfo: "Voľba kompletnosti",
                completeOnlyYes: "Chcem zaslať len kompletnú zásielku.",
                completeOnlyNo: "Chcem zaslať tovar, ktorý je k dodaniu do 2 týždňov, na ostatné počkám.",
                orderNote: "Poznámka k objednávke",
                priceOfferNote: "Poznámka k cenovej ponuke",
                
                flagOrderNote: "Chcem zadať poznámku k objednávke",
                flagPriceOfferNote: "Chcem zadať poznámku k cenovej ponuke",
                
                finishOrderInfo: "Dokončenie objednávky",
                finishPriceOfferInfo: "Dokončenie zadosťi o cenovú ponuku",
                flagNewsletter: "Prajem si dostávať informácie o novinkách a akciových ponukách",
                back: "Späť",
                submitOrder: "Dokončiť objednávku",
                submitPriceOffer: "Odoslať žiadosť o cenovú ponuku",
                checkboxOrderPrefix: "Zoznámil som sa s",
                checkboxOrderTerms: "obchodnými podmienkami",
                checkboxOrderAnd: "a podmienkami o",
                checkboxOrderPrivacy: "spracovaní osobných údajov",
                checkboxPriceOfferAgreePolicy: "Odoslaním žadosťi o cenovú ponuku potvrdzujem, že som sa zoznámil s podmienkami",
                privacyPolicyLink: "spracovaní osobných údajov",
                validation:{
                    requiredField: "Pole je povinné",
                    invalidEmail: "E-mail nie je platný",
                    selectOption: "Vyberte jednu z možností",
                    regId: "Dodávame iba zákazníkom s IČO"
                }
            },
            findByCatalogNumber:{
                label: "Přidat tovar:",
                placeholder: "kód tovaru z katalógu"
            },
            orderFailed: {
                headline: "Jejda...",
                message1: "Pri zpracovani objednavky doslo k chybe cislo:",
                message2: "Prosim kontaktujte nasi podporu.",
                tryAgain: "Zkusit znovu"
            },
            orderProcessing: {
                headline: "Spracovanie",
                message: "Vaša požiadavka sa spracováva..."
            }
        }
        
    },
    search: {
        placeholder: "Hľadaný výraz ...",
        results: {
            headline: "Hľadaný výraz:",
            noResults: "Ľutujeme, Vaším kritériam nezodpovedá žiadny výsledok.",
            contactLink: "Dopytovať sa cez Kontaktný formulár",
            categories: "Kategorie",
            products: "Produkty",
            pages: "Stránky",
            totalProducts: "produktu celkem"
        }
    }


};